module.exports = __webpack_public_path__ + "media/sergio.08ed067a.mp4";